import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'

type TotalSelector = (state: ReduxState) => number
const getTotalAlerts: TotalSelector = state => state.alerts.pagination.total

export const totalSelector: TotalSelector = createSelector(getTotalAlerts, total => total)
